export default "__VITE_ASSET__CCHPIGIo__"